export { LANDSCAPE_COMPRESSED_CONTENT_MAX_HEIGHT } from "#landscape-layout-constants";
